import React from 'react'
import sliderBtnShevron from '../../assets/images/slider/sliderScrollIcon.svg'
const CarouselCustomBtn = ({ disabled = false }) => {
  return (
    <img
      style={{
        borderRadius: '0 48px 48px 0',
        height: '58px',
        width: '30px',
        background: 'rgba(0,0,0,0.35)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        cursor: disabled ? 'text' : 'pointer',
        '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
        '&:hover': {
          background: 'rgba(0,0,0,0.3)',
        },
        zIndex: 100,
        opacity: disabled ? '.24' : 1,
      }}
      alt='control button'
      src={sliderBtnShevron}
    />
  )
}

export default CarouselCustomBtn
